export const getBarChartSeries = (crossQuestion, tableData) => {
  let tempArray = [];

  for (var i = 0; i < tableData.length - 1; i++) {
    let questionAnswer = crossQuestion.answers[i];

    let goalArray = [];

    // For Counts = 0 no Error lines
    if (Number(tableData[i][1]) > 0) {
      let underlimit = Number(tableData[i][1]) - Number(tableData[i][2]);
      let upperlimit = Number(tableData[i][1]) + Number(tableData[i][2]);
      goalArray.push({
        name: "MAX",
        value: upperlimit > 0 ? Number(upperlimit.toFixed(1)) : 0,
        strokeWidth: 0,
        strokeHeight: 10,
        strokeLineCap: "round",
        strokeColor: "#555",
      });
      goalArray.push({
        name: "MIN",
        value: underlimit > 0 ? Number(underlimit.toFixed(1)) : 0,
        strokeWidth: 0,
        strokeHeight: 10,
        strokeLineCap: "round",
        strokeColor: "#555",
      });
    }

    let tempObject = {
      x: questionAnswer?.desc,
      y: Number(tableData[i][1]).toFixed(1),
      count: Number(tableData[i][0]).toFixed(0),
      error: Number(tableData[i][2]).toFixed(1),
      goals: goalArray,
    };

    tempArray.push(tempObject);
  }

  return [
    {
      data: tempArray,
    },
  ];
};
